import { z } from 'zod';
import { createRESTContract } from '../../index';
import {
  UpdateWeeklyBriefSettingsSchema,
  WeeklyBriefDetailSchema,
  WeeklyBriefListQuerySchema,
  WeeklyBriefListResponseSchema,
  WeeklyBriefParamsSchema,
  WeeklyBriefSendTestResponseSchema,
  WeeklyBriefSettingsSchema,
} from './weekly-brief.schema';

/**
 * Weekly Intelligence Brief - settings, history and approval for the selected
 * company. Every route is super-admin only: recipients and send settings are
 * managed by Conversed, and past briefs are visible to super admins only.
 */
export const weeklyBriefContract = createRESTContract({
  getSettings: {
    method: 'GET',
    path: '/weekly-brief/settings',
    superAdminOnly: true,
    response: WeeklyBriefSettingsSchema,
  },
  updateSettings: {
    method: 'PUT',
    path: '/weekly-brief/settings',
    superAdminOnly: true,
    body: UpdateWeeklyBriefSettingsSchema,
    response: WeeklyBriefSettingsSchema,
  },
  listBriefs: {
    method: 'GET',
    path: '/weekly-brief/briefs',
    superAdminOnly: true,
    query: WeeklyBriefListQuerySchema,
    response: WeeklyBriefListResponseSchema,
  },
  getBrief: {
    method: 'GET',
    path: '/weekly-brief/briefs/:briefId',
    superAdminOnly: true,
    params: WeeklyBriefParamsSchema,
    response: WeeklyBriefDetailSchema,
  },
  approveBrief: {
    method: 'POST',
    path: '/weekly-brief/briefs/:briefId/approve',
    superAdminOnly: true,
    params: WeeklyBriefParamsSchema,
    body: z.void(),
    response: WeeklyBriefDetailSchema,
  },
  rejectBrief: {
    method: 'POST',
    path: '/weekly-brief/briefs/:briefId/reject',
    superAdminOnly: true,
    params: WeeklyBriefParamsSchema,
    body: z.void(),
    response: WeeklyBriefDetailSchema,
  },
  // Builds a new brief for last week with the same code as the Monday 06:00 job.
  // No limit, and earlier briefs of that week are left as they are.
  buildNow: {
    method: 'POST',
    path: '/weekly-brief/build-now',
    superAdminOnly: true,
    body: z.void(),
    response: WeeklyBriefDetailSchema,
  },
  sendTest: {
    method: 'POST',
    path: '/weekly-brief/send-test',
    superAdminOnly: true,
    body: z.void(),
    response: WeeklyBriefSendTestResponseSchema,
  },
});
